import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Grid,
  Box,
  FormControl,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,

  Typography,
  Divider,
  Fab,
  Button,
} from "@mui/material";
import config from "../config";

import AddIcon from "@mui/icons-material/Add";

import { getFormData } from "../companyformdata";


const Company = () => {
  const {
    companyInfoFields,
    companyTypeOptions,
    businessInfoFields,
    operationalInfo,
    ownerInfoFields,
    directorInfoFields,
    taxInfoFields,
    bankingInfoFields,
    supportingDocumentsFields,
  } = getFormData();

  const { API_BASE_URL } = config;

  const [companyType, setCompanyType] = useState("");
  const [otherValue, setOtherValue] = useState("");

  const [companyFormData, setCompanyFormData] = useState({
    companyInfo: {},
    businessInfo: {},
    operationalInfo: {},
    ownerInfo: [
      { name: "", percentageofownership: "", nationality: "", contact: "" },
    ],
    directors: [{ name: "", position: "", nationality: "", contact: "" }],
    taxInfo: {},
    bankingInfo: {},
    documents: [],
  });

  const handleChange = (event) => {
    setCompanyType(event.target.value);
    if (event.target.value !== "other") {
      setOtherValue(""); // Reset other value if another option is selected
    }
    
  };

  const handleOtherChange = (event) => {
   
    setOtherValue(event.target.value);
  };

  const handleInputChange = (section, index, field, value) => {
    const updatedValues = { ...companyFormData };
    if (section === "ownerInfo" || section === "directors") {
      updatedValues[section][index][field] = value;
    } else {
      updatedValues[section][field] = value;
    }
   
    setCompanyFormData(updatedValues);
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    setCompanyFormData((prevValues) => ({
      ...prevValues,
      documents: files,
    }));
  };



  const [directors, setDirectors] = useState([
    { name: "", position: "", nationality: "", contact: "" },
  ]);

  const [gridItems, setGridItems] = useState([
    { name: "", nationality: "", percentageofownership: "", contact: "" },
  ]);

  const handleAddItem = () => {
    setGridItems([
      ...gridItems,
      { name: "", nationality: "", percentageofownership: "", contact: "" },
    ]);
  };

  const handleDirectorAdd = () => {
    setDirectors([
      ...directors,
      { name: "", position: "", nationality: "", contact: "" },
    ]);
  };  

  const handleCompanyClick = async (e) => {
    // e.preventDefault();
    const dataToSend = {
      companyType,
      otherValue,
      ...companyFormData,
    };

   

    try {
      const response = await axios.post(`${API_BASE_URL}/api/kyc`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          // Include any authentication headers if needed
        },
      });

      if (response.data.success) {
       
        // Handle success (e.g., show a success message, redirect, etc.)
      } else {
        
        // Handle failure (e.g., show an error message)
      }
    } catch (error) {
      
      // Handle error (e.g., show an error message)
    }
  };

  return (    
    <>
    {/* <Kyc/> */}
      <Box sx={{ flexGrow: 1, marginBottom: "20px", marginTop:"20px"  }} className="w-100">
        <Grid
          container
          spacing={2}
          justifyContent="flex-center"
          className="justify-content-center mt-3"
        >
          <Grid item xs={10} className="">
            <Box
              sx={{
                padding: "16px",
                background:
                  "linear-gradient(90deg, rgba(181,178,235,1) 10%, rgba(189,206,247,1) 35%, rgb(251 172 101 / 99%) 80%)",
              }}
            >
              <h5 className="fw-bold">Company Information</h5>
              <Grid container spacing={2} direction="row" className="pb-3">
                {companyInfoFields.slice(0, 3).map((info) => {
                  return (
                    <Grid
                      item
                      xs={4}
                      // key={info.id}
                    >
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        value={companyFormData.companyInfo[info.id] || ""}
                       
                        onChange={(e) =>
                          handleInputChange(
                            "companyInfo",
                            null,
                            info.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}

                <div className="d-flex align-items-center">
                  <FormControl compone2nt="fieldset">
                    <p className="fw-bold text-start ms-3 mt-3 mb-0">
                      Company Type:
                    </p>
                    <RadioGroup
                      aria-label="company-type"
                      name="company-type"
                      value={companyType}
                      className="ms-3"
                      onChange={handleChange}
                      row // To display the radio buttons inline
                    >
                      {companyTypeOptions.map((type, index) => {
                        return (
                          <FormControlLabel
                            key={type.value}
                            value={type.value}
                            control={<Radio />}
                            label={type.label}
                          />
                        );
                      })}
                      <FormControlLabel
                        value="other"
                        control={<Radio />}
                        label={
                          <>
                            Other (Please Specify):
                            <TextField
                              id="standard-basic"
                              value={otherValue}
                              onChange={handleOtherChange}
                              variant="standard"
                              size="small"
                              style={{ marginLeft: 8 }}
                            />
                          </>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Registration Details:
                </p>
                {companyInfoFields.slice(3, 6).map((info, index) => {
                  return (
                    <Grid item xs={4} key={info.id}>
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        variant="outlined"
                        type={info.type}
                        value={companyFormData.companyInfo[info.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "companyInfo",
                            null,
                            info.id,
                            e.target.value
                          )
                        }
                        className="d-block"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Company Address:
                </p>
                {companyInfoFields.slice(6, 11).map((info, index) => {
                  return (
                    <Grid item xs={4} key={info.id}>
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        variant="outlined"
                        value={companyFormData.companyInfo[info.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "companyInfo",
                            null,
                            info.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Contact Information:
                </p>
                {companyInfoFields.slice(11).map((info, index) => {
                  return (
                    <Grid item xs={4} key={info.index}>
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        variant="outlined"
                        value={companyFormData.companyInfo[info.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "companyInfo",
                            null,
                            info.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-3 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold">Business Information</h5>
              <Grid container spacing={2} alignItems="center">
                {businessInfoFields.map((businessinfo, index) => {
                  return (
                    <Grid item xs={4} key={businessinfo.id}>
                      <TextField
                        fullWidth
                        placeholder={businessinfo.placeholder}
                        variant="outlined"
                        value={
                          companyFormData.businessInfo[businessinfo.id] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "businessInfo",
                            null,
                            businessinfo.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold">Operational Information</h5>
              <Grid container spacing={2} alignItems="center">
                {operationalInfo.map((info, index) => {
                  return (
                    <Grid item xs={4} key={info.id}>
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        variant="outlined"
                        value={companyFormData.operationalInfo[info.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "operationalInfo",
                            null,
                            info.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold">Ownership Information</h5>
              <Grid container spacing={2} alignItems="center">
                <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                  Shareholders
                </h6>
                <p className="fw-bold text-start w-100 ms-3 mb-0">
                  List of Shareholders (with more than 10% ownership):
                </p>
                {companyFormData.ownerInfo.map((item, index) => (
                  <React.Fragment key={index}>
                    {ownerInfoFields.map((ownerinfo, i) => (
                      <Grid item xs={3} key={`${ownerinfo.category}-${i}`}>
                        <TextField
                          fullWidth
                          placeholder={ownerinfo.placeholder}
                          variant="outlined"
                          value={item[ownerinfo.id]}
                          onChange={(e) =>
                            handleInputChange(
                              "ownerInfo",
                              index,
                              ownerinfo.id,
                              e.target.value
                            )
                          }
                          sx={{
                            border: "1px solid grey",
                            borderRadius: "6px",
                            fontSize: "0.7rem",
                          }}
                        />
                      </Grid>
                    ))}
                  </React.Fragment>
                ))}
                <Fab
                  color="secondary"
                  aria-label="add"
                  className="mt-2 ms-3"
                  sx={{ height: "20px", width: "35px" }}
                  onClick={handleAddItem}
                >
                  <AddIcon className="" />
                </Fab>
                {/* Directors/Key Management Personnel Section */}
                <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                  Directors/Key Management Personnel
                </h6>
                <p className="fw-bold text-start w-100 ms-3 mb-0">
                  List of Directors/Key Management Personnel:
                </p>
                {companyFormData.directors.map((director, index) => (
                  <React.Fragment key={index}>
                    {directorInfoFields.map((info, i) => (
                      <Grid item xs={3} key={`${info.category}-${i}`}>
                        <TextField
                          fullWidth
                          placeholder={info.placeholder}
                          variant="outlined"
                          value={director[info.id]}
                          onChange={(e) =>
                            handleInputChange(
                              "directors",
                              index,
                              info.id,
                              e.target.value
                            )
                          }
                          sx={{
                            border: "1px solid grey",
                            borderRadius: "6px",
                            fontSize: "0.7rem",
                          }}
                        />
                      </Grid>
                    ))}
                  </React.Fragment>
                ))}
                <Fab
                  color="secondary"
                  aria-label="add"
                  className="mt-2 ms-3"
                  sx={{ height: "20px", width: "35px" }}
                  onClick={handleDirectorAdd}
                >
                  <AddIcon className="" />
                </Fab>
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold mt-3">Tax Information</h5>
              <Grid container spacing={2} alignItems="center">
                {/* Tax Identification Number */}
                {taxInfoFields.map((taxinfo, index) => (
                  <React.Fragment key={taxinfo.id}>
                    {/* Conditionally render22 a heading for AML Compliance */}
                    {taxinfo.id === "amlComplianceImplemented" && (
                      <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                        Anti-Money Laundering (AML) Compliance:
                      </h6>
                    )}

                    {/* Render text fields or radio group based on type */}
                    {taxinfo.type === "radio" ? (
                      <Grid item {...taxinfo.grid}>
                        <Typography
                          component="p"
                          className="ms-0"
                          sx={{
                            fontSize: "0.9rem",
                          }}
                        >
                          {taxinfo.placeholder}
                        </Typography>
                        <RadioGroup row>
                          {taxinfo.options.map((option) => (
                            <FormControlLabel
                              key={option.value}
                              value={option.value}
                              control={<Radio />}
                              label={option.label}
                              sx={{ fontSize: "0.7rem" }}
                            />
                          ))}
                        </RadioGroup>
                      </Grid>
                    ) : (
                      <Grid item {...taxinfo.grid} xs={4}>
                        <TextField
                          fullWidth
                          placeholder={taxinfo.placeholder}
                          variant="outlined"
                          type={taxinfo.type}
                          value={companyFormData.taxInfo[taxinfo.id] || ""}
                          onChange={(e) =>
                            handleInputChange(
                              "taxInfo",
                              null,
                              taxinfo.id,
                              e.target.value
                            )
                          }
                          sx={{
                            border: "1px solid grey",
                            borderRadius: "6px",
                            fontSize: "0.7rem",
                          }}
                        />
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold mt-">Banking Information</h5>
              <Grid container spacing={2} alignItems="center">
                {/* Primary Bank */}
                {bankingInfoFields.map((bankinginfo, index) => {
                  return (
                    <Grid item xs={4} key={bankinginfo.id}>
                      <TextField
                        fullWidth
                        placeholder={bankinginfo.placeholder}
                        variant="outlined"
                        value={
                          companyFormData.bankingInfo[bankinginfo.id] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "bankingInfo",
                            null,
                            bankinginfo.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <h6 className="fw-bold text-start w-100 mt-4 mb-3">
                Supporting Documents
              </h6>
              <Grid container spacing={2} alignItems="center">
                {/* Documents Required */}
                <p className="fw-bold text-start w-100 ms-3 mb-0">
                  Documents Required:
                </p>
                {supportingDocumentsFields.map((doc, index) => {
                 
                  return (
                    <Grid item xs={6} key={doc.id} className="text-start">
                      <FormControlLabel
                        control={<Checkbox name={doc.id} />}
                        label={doc.label}
                        value={companyFormData.documents[doc.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "documents",
                            null,
                            doc.id,
                            e.target.value
                          )
                        }
                      />
                    </Grid>
                  );
                })}
                <Grid item xs={12} className="text-start">
                  <input
                    type="file"
                    name="documents"
                    multiple
                    onChange={handleFileChange}
                  />
                </Grid>
              </Grid>
              <Button onClick={handleCompanyClick}>
                <Fab
                  variant="extended"
                  size="small"
                  sx={{
                    width: "100px",
                    height: "25px",
                    backgroundColor: "#e7c305",
                  }}
                >
                  <span style={{ fontSize: "0.6rem" }} className="fw-bold">
                    Submit
                  </span>
                </Fab>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>    
  );
};

export default Company;
